import {
  Component, ElementRef, EventEmitter, HostListener, Input, OnChanges,
  OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  standalone: true,
  imports: [
    NgClass,
    NgIf
  ],
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
  }
  @Input() ignoreInnerClick = false;
  @Input() isOpen = false;
  @Input() widthOfSelectBox = false;
  @ViewChild('childDropdown') childDropdown?: ElementRef;
  @ViewChild('currentScope') currentScope?: ElementRef;
  @Input() dropdownWidthClass = '';
  @Input() dropdownToggleClass = '';

  @Output() onClose?: EventEmitter<any>;

  ngOnInit(): void {
    //this.updateDropdownWidth();
  }

  public toggleMenu(fromIcon:boolean, $event: any): void {
    if(!this.ignoreInnerClick){
      $event.preventDefault();
      $event.stopPropagation();
    }

    if(this.isOpen) {
      if(!this.ignoreInnerClick || fromIcon){
        this.isOpen = false;
      }
    } else {
      if(!this.ignoreInnerClick || fromIcon){
        this.isOpen = true;
      }

    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateDropdownWidth();
  }

  @HostListener('document:click', ['$event'])
  public closeHostClick($event: any): void {

    if (
        !this.currentScope?.nativeElement.contains($event.target) &&
        !(this?.childDropdown?.nativeElement.contains($event.target)) &&
        this.isOpen
    ) {
      $event.preventDefault();
      $event.stopPropagation();
      this.isOpen = false;
      if(this.onClose){
        this.onClose.emit();
      }
    }
  }

  private updateDropdownWidth(): void {
    this.dropdownWidthClass = 'w-[200px]';
  }
}
